import React, { useState } from "react";
import { useLsp } from "../store/LspContext";
import { apiUploadDocuments } from "../api/lspApi";

export default function UploadDocumentsPage() {
    const { state } = useLsp();
    const [docType, setDocType] = useState("pan");
    const [file, setFile] = useState(null);
    const [out, setOut] = useState("");
    const [loading, setLoading] = useState(false);

    const run = async () => {
        setLoading(true); setOut("");
        try {
            if (!file) throw new Error("Please select a file");
            const res = await apiUploadDocuments(state.baseUrl, state.token, state.partnerLoanId, docType, file);
            setOut(JSON.stringify(res, null, 2));
        } catch (e) {
            setOut("❌ " + e.message);
        } finally { setLoading(false); }
    };

    return (
        <div style={card}>
            <h2 style={h2}>8) Upload Documents</h2>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
                <select style={inp} value={docType} onChange={(e) => setDocType(e.target.value)}>
                    <option value="pan">pan</option>
                    <option value="aadhar">aadhar</option>
                    <option value="photo">photo</option>
                    <option value="bank_statement">bank_statement</option>
                    <option value="misc">misc (cibil_report etc.)</option>
                </select>
                <input type="file" onChange={(e) => setFile(e.target.files?.[0] || null)} />
                <button style={btn} onClick={run} disabled={loading || !state.token || !state.partnerLoanId}>
                    Upload
                </button>
            </div>
            <pre style={pre}>{loading ? "⏳ loading..." : out || "No response yet"}</pre>
        </div>
    );
}
const card = { padding: 16, border: "1px solid #334155", borderRadius: 12, background: "#0f172a" };
const h2 = { marginTop: 0 };
const inp = { padding: 10, borderRadius: 10, border: "1px solid #334155", background: "#fffff", color: "#e5e7eb", width: 240 };
const btn = { padding: "10px 14px", borderRadius: 10, border: "1px solid #475569", background: "#1f2937", color: "#e5e7eb", cursor: "pointer" };
const pre = { marginTop: 12, background: "#fffff", border: "1px solid #334155", borderRadius: 10, padding: 12, overflow: "auto", maxHeight: 360 };
